import { Box } from '@bonanza-social/moonlight';
import { ShopItemType } from '../../state/items/items.types';
import Price from '../Price/Price';
import { memo, useMemo } from 'react';

const countDigits = (n: number | null) =>
  n == null ? 0 : String(Math.trunc(Math.abs(n))).length;

function ShopItemPrice({ price, sale }: ShopItemType) {
  const [currentPrice, oldPrice] = useMemo(
    () => (sale ? [sale.price, price] : [price, null]),
    [price, sale],
  );

  const maxDigits = useMemo(
    () => Math.max(countDigits(currentPrice), countDigits(oldPrice)),
    [currentPrice, oldPrice],
  );

  const flexDirection = useMemo(() => {
    const shouldStack = maxDigits > 8;

    if (!shouldStack) {
      return 'row';
    }

    if (oldPrice) {
      return 'column-reverse';
    }

    return 'column';
  }, [maxDigits, oldPrice]);

  return (
    <Box
      flexDirection={flexDirection}
      gap="space-200"
      alignItems={flexDirection === 'row' ? 'center' : 'flex-start'}
    >
      <Price amount={currentPrice} />
      {oldPrice ? <Price amount={oldPrice} strikethrough /> : null}
    </Box>
  );
}

export default memo(ShopItemPrice);
